"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _contract = _interopRequireDefault(require("./contract"));

var _Lighthouse = _interopRequireDefault([{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "stakes",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x16934fc4"
}, {
  constant: true,
  inputs: [],
  name: "xrt",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x330f9588"
}, {
  constant: true,
  inputs: [],
  name: "marker",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x3acddfc1"
}, {
  constant: true,
  inputs: [],
  name: "keepAliveBlock",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x4ed75ded"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "providers",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x50f3fc81"
}, {
  constant: true,
  inputs: [],
  name: "timeoutInBlocks",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x678bd169"
}, {
  constant: true,
  inputs: [],
  name: "minimalStake",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x9ec41a2d"
}, {
  constant: true,
  inputs: [],
  name: "providersLength",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xad23fe73"
}, {
  constant: true,
  inputs: [],
  name: "factory",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xc45a0155"
}, {
  constant: true,
  inputs: [],
  name: "quota",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xcebe09c9"
}, {
  constant: true,
  inputs: [{
    name: "_provider",
    type: "address"
  }],
  name: "quotaOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xef23b3a3"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "indexOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xfd6aad25"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "provider",
    type: "address"
  }],
  name: "Online",
  type: "event",
  signature: "0xb87e760cbc2db6791d417f8be7b6b859468d348a1e174f37374530d391b9cb57"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "provider",
    type: "address"
  }],
  name: "Offline",
  type: "event",
  signature: "0x3bc83fff2907676f544f59cca17a4d818ad142c57b57bc028867db31ca8e5b35"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "provider",
    type: "address"
  }, {
    indexed: true,
    name: "quota",
    type: "uint256"
  }],
  name: "Current",
  type: "event",
  signature: "0xd3bed6b350c548f8ecd5aa592c13a6a67bff7ccf6aae87aa3743bc25d8b130e3"
}, {
  constant: false,
  inputs: [{
    name: "_xrt",
    type: "address"
  }, {
    name: "_minimalStake",
    type: "uint256"
  }, {
    name: "_timeoutInBlocks",
    type: "uint256"
  }],
  name: "setup",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x64f6f7b9"
}, {
  constant: false,
  inputs: [{
    name: "_value",
    type: "uint256"
  }],
  name: "refill",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xca9d07ba"
}, {
  constant: false,
  inputs: [{
    name: "_value",
    type: "uint256"
  }],
  name: "withdraw",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x2e1a7d4d"
}, {
  constant: false,
  inputs: [{
    name: "_demand",
    type: "bytes"
  }, {
    name: "_offer",
    type: "bytes"
  }],
  name: "createLiability",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xd2b962f2"
}, {
  constant: false,
  inputs: [{
    name: "_liability",
    type: "address"
  }, {
    name: "_result",
    type: "bytes"
  }, {
    name: "_success",
    type: "bool"
  }, {
    name: "_signature",
    type: "bytes"
  }],
  name: "finalizeLiability",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x563e52d5"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Lighthouse = /*#__PURE__*/function (_Contract) {
  _inherits(Lighthouse, _Contract);

  var _super = _createSuper(Lighthouse);

  function Lighthouse(web3, address) {
    var _this;

    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    _classCallCheck(this, Lighthouse);

    _this = _super.call(this, web3, _Lighthouse["default"], address);
    _this.name = name;
    return _this;
  }

  _createClass(Lighthouse, [{
    key: "getProviders",
    value: function () {
      var _getProviders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var providers, count, i, provider;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                providers = [];
                _context.next = 3;
                return this.methods.providersLength().call();

              case 3:
                count = _context.sent;
                i = 0;

              case 5:
                if (!(i < count)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 8;
                return this.methods.providers(i).call();

              case 8:
                provider = _context.sent;
                providers.push(_web3Utils["default"].toChecksumAddress(provider));

              case 10:
                i++;
                _context.next = 5;
                break;

              case 13:
                return _context.abrupt("return", providers);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProviders() {
        return _getProviders.apply(this, arguments);
      }

      return getProviders;
    }()
  }, {
    key: "getInfo",
    value: function getInfo() {
      return Promise.all([this.methods.minimalStake().call(), this.methods.timeoutInBlocks().call(), this.methods.keepAliveBlock().call(), this.methods.marker().call(), this.methods.quota().call()]).then(function (info) {
        return {
          minimalStake: Number(info[0]),
          timeoutInBlocks: Number(info[1]),
          keepAliveBlock: Number(info[2]),
          marker: Number(info[3]),
          quota: Number(info[4])
        };
      });
    }
  }]);

  return Lighthouse;
}(_contract["default"]);

exports["default"] = Lighthouse;